import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck } from 'lucide-react';
export function GuaranteeSection() {
  return <section className="py-20 bg-emerald-50 border-y border-emerald-100" data-id="element-141">
      <div className="container mx-auto px-4 text-center" data-id="element-142">
        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="max-w-2xl mx-auto bg-white rounded-3xl p-8 md:p-12 shadow-xl border border-emerald-100" data-id="element-143">
          <div className="inline-flex items-center justify-center w-20 h-20 rounded-full bg-emerald-100 text-emerald-600 mb-6" data-id="element-144">
            <ShieldCheck className="w-10 h-10" data-id="element-145" />
          </div>

          <h2 className="text-3xl font-extrabold text-slate-900 mb-4" data-id="element-146">
            GARANTÍA 7 DÍAS — SIN PREGUNTAS
          </h2>

          <p className="text-lg text-slate-600 mb-6" data-id="element-147">
            Abrís los tomos. Los usás. Si en 7 días no es lo que esperabas:
          </p>

          <div className="bg-emerald-50 text-emerald-800 font-bold text-xl py-4 px-6 rounded-xl mb-6 border border-emerald-200" data-id="element-148">
            Devolución del 100% sin formularios, sin drama.
          </div>

          <p className="text-sm text-slate-500 font-medium uppercase tracking-wider" data-id="element-149">
            Tasa de devoluciones: menos del 1%.
          </p>
        </motion.div>
      </div>
    </section>;
}